module.exports = __webpack_public_path__ + "img/wealthfooter2.29eb8b09.png";